import { createAction } from 'redux-actions';

const PREFIX = 'FRESHDESK';

export const startBootstrap = createAction(`${PREFIX}/setShow`);
export const setInitialized = createAction(`${PREFIX}/setInitialized`);
